import React, { useState } from 'react'
import NetBushelsReport from './NetBushelsReport'
import './Reports.scss'
import Select from '../../dpe-usco/components/Select/Select'
import CompanyAdminReport from './CompanyAdminReport'
import ProgramsReport from './ProgramsReport'

const Reports = () => {
  const [reportOptions] = useState(['Net Bushels','Company Admin', 'Program'])
  const [reportType, setReportType] = useState('Net Bushels')

  const handleTypeSelect = type => {
    if (type !== reportType) {
      setReportType(type)
    }
  }
  const reportComponents = {
    'Net Bushels': <NetBushelsReport />,
    'Company Admin': <CompanyAdminReport />,
    'Program': <ProgramsReport />
  }
  return (<>
    <div className="App"> 
      <header className='m25'>
        <div className='report-type'>
          <div>Report type : </div>
          <div className="w200 select-btn" style={{ fontWeight:'bold' }} >
            <Select
              handleSelection={handleTypeSelect}
              defaultValue={'Net Bushels'}
              options={reportOptions}
            />
          </div>
        </div>
      </header>
      {reportComponents[reportType]}
    </div>
  </>
  )
}

export default Reports